import { useEffect, useState, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import API from "../api/api";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function FeaturedSlider() {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        API.get("/api/articles/trending")
            .then((res) => {
                if (!mounted) return;
                const data = Array.isArray(res.data) ? res.data : [];
                setArticles(data.slice(0, 6));
            })
            .catch((err) => {
                console.error("Error fetching featured articles:", err);
            })
            .finally(() => {
                if (mounted) setLoading(false);
            });

        return () => {
            mounted = false;
        };
    }, []);

    const slides = useMemo(() => articles, [articles]);

    /* -------------------- SKELETON LOADER -------------------- */
    if (loading) {
        return (
            <section className="px-6 mt-4">
                <div className="h-64 sm:h-80 md:h-[420px] rounded-xl bg-gray-200 animate-pulse" />
            </section>
        );
    }

    if (!slides.length) return null;

    return (
        <section className="px-6 mt-4">
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                navigation
                pagination={{ clickable: true }}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                loop={false}                // ❌ removed loop for performance
                spaceBetween={20}
                className="rounded-xl overflow-hidden"
            >
                {slides.map((article, index) => (
                    <SwiperSlide key={article.id}>
                        <Link to={`/article/${article.slug}`}>
                            <div className="relative h-64 sm:h-80 md:h-[420px] cursor-pointer">

                                {/* IMAGE */}
                                <img
                                    src={article.images || "https://picsum.photos/1200/600"}
                                    alt={article.title}
                                    loading={index === 0 ? "eager" : "lazy"}
                                    className="w-full h-full object-cover"
                                />

                                {/* OVERLAY */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

                                {/* BADGES */}
                                <div className="absolute top-4 left-4 flex gap-2">
                                    {article.category && (
                                        <span className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase">
                                            {article.category.replace("-", " ")}
                                        </span>
                                    )}
                                    {article.sport && (
                                        <span className="bg-black/70 text-white text-xs font-semibold px-3 py-1 rounded-full uppercase">
                                            {article.sport}
                                        </span>
                                    )}
                                </div>

                                {/* TITLE */}
                                <div className="absolute bottom-6 left-6 right-6 text-white">
                                    <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold leading-tight line-clamp-2">
                                        {article.title}
                                    </h2>
                                </div>

                            </div>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
